import type { FC } from 'react';
import { VideoOff } from 'lucide-react';
import { t } from '../i18n';

/**
 * Video Bunny'da saqlangan, Bunny esa hozir ishlamayapti (server
 * `videoUnavailable` deydi, `videoUrl` bermaydi).
 *
 * Ilgari o'quvchi bu holatda QORA pleyer ko'rardi va sababini bilmasdi:
 * "internetim yomonmi?" deb kutib o'tirardi. Bunny tiklansa belgi o'zi
 * yo'qoladi (server holatni har 10 daqiqada tekshiradi).
 */
export const VideoUnavailable: FC = () => (
  <div className="callout callout-warning" role="status">
    <VideoOff size={17} style={{ flex: 'none' }} aria-hidden="true" />
    <span>
      {t(
        'Video vaqtincha mavjud emas. Ustozingiz uni qayta yuklashi kerak — bu sizning internetingiz bilan bogʻliq emas.',
      )}
    </span>
  </div>
);
